module.exports = __webpack_public_path__ + "img/04.6da637f0.gif";